import {Component, Input, OnInit} from '@angular/core';
import {AccordionModule} from "primeng/accordion";
import {BottomSliderComponent} from "../component/bottom-slider/bottom-slider.component";
import {CheckboxChangeEvent, CheckboxModule} from "primeng/checkbox";
import {DataViewModule} from "primeng/dataview";
import {KeyValuePipe, NgForOf, NgIf} from "@angular/common";
import {SharedModule} from "primeng/api";
import {StoryListItemComponent} from "../success-story-list-page/story-list-item/story-list-item.component";
import {Pages} from "../../dto/Pages";
import {TemplateComponent} from "../template/template.component";
import {PageListItemComponent} from "./page-list-item/page-list-item.component";

@Component({
  selector: 'app-other-page-list',
  standalone: true,
    imports: [
        AccordionModule,
        BottomSliderComponent,
        CheckboxModule,
        DataViewModule,
        KeyValuePipe,
        NgForOf,
        SharedModule,
        StoryListItemComponent,
        PageListItemComponent,
        NgIf
    ],
  templateUrl: './other-page-list.component.html',
  styleUrl: './other-page-list.component.css'
})
export class OtherPageListComponent extends TemplateComponent implements  OnInit {
    @Input() pageType='PAGE';
    pages:Array<Pages> = new Array<Pages>();
    topPage:Pages= new Pages();
    totalPages:number=0;
    attributFilterList:Map<string,Set<string>> = new Map<string, Set<string>>();
    selectedFilter:Set<string>= new Set<string>();
    listSummery: string="";
    listTitle: string="";
    defListCount:number=6;

    ngOnInit() {
        this.titleService.setTitle("Search as a service");
        document.body.scrollTop = 0;
        if(this.route.url.startsWith("/features")){
            this.pageType="FEATURE";
            this.listTitle=$localize`:@@Searchia Search and Discovery Features:Searchia Search and Discovery Features`;
            this.listSummery  = JSON.parse(this.global.getMainData()['list-pages']['data'])['features']['text'];
        }
        else if(this.route.url.startsWith("/pages")){
            this.pageType="PAGE";
            this.listTitle='';
            this.listSummery  = JSON.parse(this.global.getMainData()['list-pages']['data'])['pages']['text'];
        }
        else if(this.route.url.startsWith("/blogs")){
            this.pageType="BLOG";
            this.listTitle=$localize`:@@Blogs:Blogs`,
            this.listSummery  = JSON.parse(this.global.getMainData()['list-pages']['data'])['blogs']['text'];
        }
        else if(this.route.url.startsWith("/all-news")){
            this.pageType="NEWS";
            this.listTitle=$localize`:@@News:News`,
            this.listSummery  = JSON.parse(this.global.getMainData()['list-pages']['data'])['news']['text'];
        }
        else if(this.route.url.startsWith("/customers")){
            this.pageType="CUSTOMER";
            this.listTitle=$localize`:@@Customers:Customers`,
            this.listSummery  = JSON.parse(this.global.getMainData()['list-pages']['data'])['customers']['text'];
        }
        this.loadAttribute();
    }

    loadPageData(table) {
        this.global.progressBar = true;
        let filter:string="";
        for (let value of this.selectedFilter.values()) {
            filter+=("&filter="+value);
        }
        var observable = this.restBack.doGet("lnd/site/get_page_list?" +
            "page=" + (table != null ? table.first / this.defListCount : 0) +
            "&nrpp=" + (table != null && table.rows ? table.rows : this.defListCount)+
            "&type=" +this.pageType+
            filter +
            "" );

        observable.subscribe({
            next: (res: string) => {
                if (res["status"] == 200) {
                    document.body.scrollTop = 0;
                    this.pages = res["entity"];
                    if(this.pageType=="NEWS" || this.pageType=="BLOG") {
                        if (this.pages.length > 0) {
                            this.topPage = this.pages[0];
                            this.pages = this.pages.filter((p) => p != this.topPage);
                        }
                    }

                    this.totalPages= res["total"];
                }
                return res;
            },
            error: (e) => {
                this.messageService.clear();
                this.messageService.add({
                        severity: 'error',
                        summary: $localize`:@@Error:Error`,
                        detail: $localize`:@@Server Timout Det:Server Timout Det`
                    }
                );
            },
            complete: () => {
                this.global.progressBar = false;
            }
        });
    }
    loadAttribute() {
        this.global.progressBar = true;
        var observable = this.restBack.doGet("lnd/site/get_attribute?" +
            "type=" +this.pageType );
        observable.subscribe({
            next: (res: string) => {
                if (res["status"] == 200) {
                    this.attributFilterList = res["entity"];
                    // console.log(this.attributFilterList);

                }
                return res;
            },
            error: (e) => {
                this.messageService.clear();
                this.messageService.add({
                        severity: 'error',
                        summary: $localize`:@@Error:Error`,
                        detail: $localize`:@@Server Timout Det:Server Timout Det`
                    }
                );
            },
            complete: () => {
                this.global.progressBar = false;
            }
        });
    }

    filterByAttribute(event: CheckboxChangeEvent, filter: string) {
        if(event.checked) {
            this.selectedFilter.add(filter);
        }else {
            this.selectedFilter.delete(filter);
        }
        this.loadPageData(null);

    }

    clickMoreList() {
        document.getElementById('page-list').scrollIntoView();
        document.body.scrollBy(0,-50);
    }

    goToPage(pageuid: String) {
        if(this.pageType=="SUCCESS_STORY"){
            this.route.navigate(["/success_story/"+pageuid])
        }else if(this.pageType=="PAGE"){
            this.route.navigate(["/page/"+pageuid])
        }else if(this.pageType=="FEATURE"){
            this.route.navigate(["/feature/"+pageuid])
        }else if(this.pageType=="BLOG"){
            this.route.navigate(["/blog/"+pageuid])
        }else if(this.pageType=="NEWS"){
            this.route.navigate(["/news/"+pageuid])
        }else if(this.pageType=="CUSTOMER"){
            this.route.navigate(["/customer/"+pageuid])
        }

    }
}
